var _defs, _text, _path, _text2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 398.22 250.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff8100;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        font-size: 62.69px;\n      }\n\n      .cls-2, .cls-3 {\n        font-family: Futura-Medium, Futura;\n        font-weight: 500;\n      }\n\n      .cls-4, .cls-5 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: .8px;\n      }\n\n      .cls-5 {\n        stroke-dasharray: 2.23 2.23;\n      }\n\n      .cls-3 {\n        fill: #004b95;\n        font-size: 76.15px;\n      }\n\n      .cls-6 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n\n      .cls-8 {\n        letter-spacing: 0em;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(14.46 130.54) rotate(-10.53) scale(1.18 1) skewX(1.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 43.06,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 80.02,
    y: 0
  }, "ent"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 184.73,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 222.69,
    y: 0
  }, "ull"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.1,75.68l7.35,37.45s-14.04,17.84,5.69,29.04l8.07,38.75L40.69,250.97l-7.43-37.95c.62-.52,19.5-19.13-5.73-29.24l-7.24-38.25"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(83.68 206.7) rotate(-11.09) scale(1.21 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Sund"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 142.67,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 180.81,
    y: 0
  }, "y"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 52.32,
    y1: 140.19,
    x2: 52.54,
    y2: 141.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 52.96,
    y1: 143.49,
    x2: 72.5,
    y2: 243.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.72,
    y1: 244.32,
    x2: 72.94,
    y2: 245.42
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 346.55,
    y1: 82.55,
    x2: 346.77,
    y2: 83.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 347.2,
    y1: 85.84,
    x2: 366.74,
    y2: 185.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 366.95,
    y1: 186.67,
    x2: 367.17,
    y2: 187.77
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8a47b858b01294652a4509ac13fc5b09.svg";
export { ForwardRef as ReactComponent };